import axios, {
  AxiosInstance,
  AxiosError,
  InternalAxiosRequestConfig,
} from 'axios'
import { toastUtil } from '../../utils/toast'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

if (!API_BASE_URL) {
  throw new Error(
    'REACT_APP_API_BASE_URL 환경 변수가 설정되지 않았습니다. .env 파일에 REACT_APP_API_BASE_URL을 추가해주세요.'
  )
}

const adminApiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 10000,
})

adminApiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('admin_token')
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // FormData인 경우 Content-Type을 제거하여 axios가 자동으로 multipart/form-data + boundary 설정하도록 함
    if (config.data instanceof FormData && config.headers) {
      delete config.headers['Content-Type']
    }
    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  }
)

adminApiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error: AxiosError) => {
    if (error.response) {
      const status = error.response.status
      const data = error.response.data as any

      switch (status) {
        case 401:
        case 403:
          localStorage.removeItem('admin_token')
          if (window.location.pathname.startsWith('/admin')) {
            window.location.href = '/admin/login'
          }
          break
        case 422:
          break
        case 500:
          toastUtil.error('서버 오류가 발생했습니다')
          break
        default:
          if (data?.message) {
            toastUtil.error(data.message)
          } else {
            toastUtil.error('오류가 발생했습니다')
          }
      }
    } else if (error.request) {
      toastUtil.error('네트워크 오류가 발생했습니다')
    } else {
      toastUtil.error('요청 처리 중 오류가 발생했습니다')
    }

    return Promise.reject(error)
  }
)

export default adminApiClient
